import {Component, computed, OnInit, signal} from '@angular/core';
import {SnackBarService} from '@q9elements/ui-kit/common';
import {formatDistanceToNow, parseISO} from 'date-fns';

import {HistoryItem} from '../../models/history.interface';
import {AiChatDaoService} from '../../services/ai-chat-dao.service';
import {AiChatService} from '../../services/ai-chat.service';

@Component({
  selector: 'ai-chat-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss']
})
export class HistoryComponent implements OnInit {
  readonly selectedChatId = this.aiChatService.chatId;
  history = this.aiChatService.history;
  isCurrentChatDeleting = computed(() => {
    return this.deleteInProgress() === this.selectedChatId();
  });
  private readonly deleteInProgress = signal<string>(null);

  constructor(
    private snackBarService: SnackBarService,
    private aiChatService: AiChatService,
    private aiChatDaoService: AiChatDaoService
  ) {}

  ngOnInit(): void {
    this.aiChatService.loadHistory();
  }

  formatDate(date: string): string {
    return formatDistanceToNow(parseISO(date), {addSuffix: true});
  }

  onChatSelection(chat: HistoryItem) {
    const chatId = chat.id;

    if (this.selectedChatId() === chatId) {
      return void 0;
    }

    this.aiChatService.resetAssistant(chat.assistantType);
    this.selectedChatId.set(chatId);
    this.aiChatService.loadChat(chatId);
  }

  deleteChat(chatId: string) {
    this.deleteInProgress.set(chatId);

    this.aiChatDaoService.deleteChat(chatId).subscribe({
      next: () => {
        this.history.update(history => history.filter(chat => chat.id !== chatId));

        if (this.selectedChatId() === chatId) {
          this.aiChatService.resetAssistant(this.aiChatService.selectedAssistant());
        }
      },
      error: error => {
        this.snackBarService.error(error);
      },
      complete: () => {
        this.deleteInProgress.set(null);
      }
    });
  }
}
